// file-upload.service.js

import axios from 'axios';

const BASE_URL = import.meta.env.VITE_DJANGO_URL;


async function getDatosMensuales() {
  const comparativaUrl = `${BASE_URL}/consejo/comparativa-ingresos-gastos/`;
  console.log(`Llamada a la API: ${comparativaUrl}`);

  try {
    // Realizar la solicitud a la API
    const apiResponse = await fetch(comparativaUrl);

    // Verificar el estado de la respuesta
    if (!apiResponse.ok) {
      throw new Error(`Error en la respuesta: estado HTTP ${apiResponse.status}`);
    }

    // Procesar la respuesta JSON y convertir las cadenas internas en objetos
    const rawResponse = await apiResponse.json();
    console.log('Respuesta completa obtenida:', rawResponse);

    // Convertir la respuesta a un formato de array de objetos
    const parsedResponse = JSON.parse(rawResponse);
    const formattedData = parsedResponse.data.map(item => JSON.parse(item));

    console.log('Datos parseados:', formattedData);
    return { data: formattedData, mensaje: 'Datos obtenidos correctamente' };

  } catch (error) {
    console.error('Error al obtener datos mensuales:', error);
    return { data: '', mensaje: `Error al contactar con la API: ${error.message}` };
  }
}


async function uploadExcelContaplus(formData) {
  const url = `${BASE_URL}/consejo/comparativa-ingresos-gastos-contaplus/`;
  console.log("recuperando datos de excel... " + `${BASE_URL}/consejo/comparativa-ingresos-gastos-contaplus/`)
  let datos = await axios.post(`${BASE_URL}/consejo/comparativa-ingresos-gastos-contaplus/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  console.log("recuperados datos de excel")
  return datos;
}


async function uploadExcelContasol(formData) {
  const url = `${BASE_URL}/consejo/comparativa-ingresos-gastos-contasol/`;
  console.log("recuperando datos de excel... " + `${BASE_URL}/consejo/comparativa-ingresos-gastos-contasol/`)
  let datos = await axios.post(`${BASE_URL}/consejo/comparativa-ingresos-gastos-contasol/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  console.log("recuperados datos de excel")
  return datos;
}

async function putExcelContaplus(data) {
  console.log(data);
  let datosContabilidad = await axios.put(`${BASE_URL}/consejo/comparativa-ingresos-gastos-contaplus/`, {
    data: data
  })
    .then((response) => {
      return response.data
    })
    .catch(function (error) {
      console.log(error);
      return {
        data: data,
        mensaje: 'Error al contactar con la API: ' + error
      }
    })
  return datosContabilidad
}


async function putExcelContasol(data) {
  console.log(data);
  let datosContabilidad = await axios.put(`${BASE_URL}/consejo/comparativa-ingresos-gastos-contaplus/`, {
    data: data
  })
    .then((response) => {
      return response.data
    })
    .catch(function (error) {
      console.log(error);
      return {
        data: data,
        mensaje: 'Error al contactar con la API: ' + error
      }
    })
  return datosContabilidad
}




function download(data) {
  console.log("Función download iniciada");
  console.log("Datos recibidos para la descarga:", data);

  let xhr = new XMLHttpRequest();
  console.log("XMLHttpRequest creado:", xhr);

  xhr.open('POST', `${BASE_URL}/consejo/comparativa-ingresos-gastos-excel/`, true);
  console.log("Solicitud abierta a la URL:", `${BASE_URL}/consejo/comparativa-ingresos-gastos-excel/`);

  xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  console.log("Header 'Content-type' establecido como 'application/x-www-form-urlencoded'");

  xhr.setRequestHeader("data", data);
  console.log("Header 'data' establecido con el valor:", data);

  xhr.responseType = 'arraybuffer';
  console.log("Tipo de respuesta configurado como 'arraybuffer'");

  xhr.onload = function (e) {
    console.log("Evento onload activado. Estado de la respuesta:", this.status);
    if (this.status === 200) {
      console.log("Respuesta recibida con éxito. Procesando Blob...");
      
      let blob = new Blob([this.response.data], { type: "application/vnd.ms-excel" });
      console.log("Blob creado con el tipo de archivo 'application/vnd.ms-excel':", blob);

      let url = window.URL.createObjectURL(blob);
      console.log("URL temporal creada para el Blob:", url);

      let a = document.createElement("a");
      a.href = url;
      a.download = "Export table.xlsx";
      console.log("Enlace de descarga creado:", a);

      a.click();
      console.log("Descarga iniciada.");

      window.URL.revokeObjectURL(url);
      console.log("URL temporal revocada.");
    } else {
      console.error("Error en la solicitud. Estado:", this.status);
    }
  };

  console.log("Enviando solicitud...");
  xhr.send();
  console.log("Solicitud enviada.");
}

async function downloadExcel(params) {
  console.log("Función downloadExcel iniciada.");
  console.log("Parámetros recibidos:", params);

  try {
    // Realiza la solicitud POST para generar el archivo Excel
    console.log(`${BASE_URL}/consejo/comparativa-ingresos-gastos-excel/`, { data: params })
    const response = await axios.post(`${BASE_URL}/consejo/comparativa-ingresos-gastos-excel/`, { data: params });
    console.log("Respuesta de la API recibida:", response);
    const datosContabilidad = response.data.fichero;
    console.log("Contenido del fichero recibido:", datosContabilidad);

    // Realiza la solicitud GET para descargar el archivo generado
    const res = await axios.get(`${BASE_URL}/consejo/descargar/?fichero=${datosContabilidad}`, {
      responseType: "blob" // Asegura que la respuesta sea del tipo `blob` para el archivo
    });
    
    console.log("Respuesta de descarga recibida:", res);
    const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Export table.xlsx";
    a.click();
    window.URL.revokeObjectURL(url); // Libera la URL temporal
    console.log("Descarga completada y URL temporal revocada.");

    return res;
  } catch (error) {
    console.error("Error durante la operación de descarga de Excel:", error);
    throw error; // Lanza el error para manejarlo adecuadamente fuera
  }
}


export const contabilidadService = {
  uploadExcelContaplus,
  putExcelContaplus,
  putExcelContasol,
  uploadExcelContasol,
  getDatosMensuales,
  downloadExcel,
  download
}